import utils from 'helpers/utils';

const AUTH_TOKEN_KEY = 'client-token';

let AUTH_TOKEN = null;

/**
 * Clears the currently stored client token.
 */
export const clearToken = () => {
    AUTH_TOKEN = null;

    try {
        localStorage.removeItem(AUTH_TOKEN_KEY);
    } catch (e) {
        // Shh.. these people don't want us to use local storage
    }
};

/**
 * Checks the currently stored client token.
 *
 * @returns {string|null}
 */
export const getToken = () => {
    try {
        if (AUTH_TOKEN === null) {
            AUTH_TOKEN = localStorage.getItem(AUTH_TOKEN_KEY);
        }
    } catch (e) {
        // Shh.. these people don't want us to use local storage
    }

    return AUTH_TOKEN;
};

/**
 * Refreshes the client token for future usage.
 */
export const refreshToken = () => {
    AUTH_TOKEN = utils.uuid();

    try {
        localStorage.setItem(AUTH_TOKEN_KEY, AUTH_TOKEN);
    } catch (e) {
        // Shh.. these people don't want us to use local storage
    }

    return AUTH_TOKEN;
};



// WEBPACK FOOTER //
// ./src/http/clientToken.js